/** Packages may register one synchronous resolver returning a Vue Router location or null. */
export function createLoginRedirectRegistry() {
  let source = null
  let resolver = null

  return {
    register(packageSource, callback) {
      if (source !== null && source !== packageSource) {
        throw new Error(`Login redirect already registered by ${source}.`)
      }
      if (typeof callback !== 'function') {
        throw new TypeError('A login redirect resolver must be a function.')
      }
      source = packageSource
      resolver = callback
    },
    resolve(user) {
      return resolver?.(user) ?? { name: 'Home' }
    },
  }
}

export const loginRedirects = createLoginRedirectRegistry()
